(function(){
  'use strict';
  if(window.DIYClosureNotices) return;
  var C=window.DIYCalendarCore;
  if(!C) return;
  function storage(key,value){
    try {if(value!==undefined)sessionStorage.setItem(key,value);return sessionStorage.getItem(key);}
    catch(e){return null;}
  }
  function text(root,selector,value){
    var node=root.querySelector(selector);
    if(node&&node.textContent!==value)node.textContent=value;
  }
  function update(root){
    var cal=C.create(root.dataset.productionClosures);
    var today=C.nowParts().key;
    var notice=cal.notice(today,root.dataset.closureLead);
    var editor=!!(window.Shopify&&Shopify.designMode);
    if(editor&&root.dataset.closurePreview==='true'){
      var next=cal.dates.find(function(k){return k>=today;});
      if(next)notice={date:next,today:next===today};
    }
    var isRibbon=root.hasAttribute('data-closure-ribbon');
    var active=!!notice;
    if(active){
      var dateText=C.format(notice.date,isRibbon);
      var heading=(notice.today?root.dataset.closureToday:root.dataset.closureBefore)||'Closed [date]';
      text(root,'[data-closure-heading]',heading.replace(/\[date\]/g,dateText));
      text(root,'[data-closure-copy]',(root.dataset.closureDetail||'').replace(/\[date\]/g,dateText));
    }
    if(isRibbon){
      var key=notice?'closure_'+root.dataset.closureId+'_'+notice.date+'_closed':'';
      root.dataset.closureDismissKey=key;
      root.classList.toggle('production-closure-active',active);
      var message=root.querySelector('[data-closure-message]');
      if(message)message.setAttribute('aria-hidden',String(!active));
      root.querySelectorAll('.ribbon-banner-block').forEach(function(block){
        if(active){if(!block.hasAttribute('data-closure-old-aria'))block.setAttribute('data-closure-old-aria',block.getAttribute('aria-hidden')||'absent');block.setAttribute('aria-hidden','true');}
        else if(block.hasAttribute('data-closure-old-aria')){var old=block.getAttribute('data-closure-old-aria');if(old==='absent')block.removeAttribute('aria-hidden');else block.setAttribute('aria-hidden',old);block.removeAttribute('data-closure-old-aria');}
      });
      var dismissed=active?storage(key)==='true':storage('ribbon_'+root.dataset.closureId+'_closed')==='true';
      root.classList.toggle('ribbon-banner-hidden',dismissed&&!editor);
      root.style.removeProperty('--closure-height');
      if(active&&message)root.style.setProperty('--closure-height',Math.max(40,message.scrollHeight)+'px');
      if(!root._closureClose){
        root._closureClose=true;
        root.addEventListener('click',function(event){
          if(!root.classList.contains('production-closure-active')||!event.target.closest('.ribbon-close-btn'))return;
          event.preventDefault();event.stopImmediatePropagation();
          storage(root.dataset.closureDismissKey,'true');root.classList.add('ribbon-banner-hidden');
        },true);
      }
      requestAnimationFrame(function(){root.classList.add('production-notice-ready');});
    }else{
      root.hidden=!active&&!editor;
      var panel=root.querySelector('[data-closure-panel]');
      if(panel)panel.hidden=!active;
      var help=root.querySelector('[data-closure-editor-help]');
      if(help){
        help.hidden=!editor||active;
        help.textContent=cal.invalid.length?'Invalid closed date(s): '+cal.invalid.join(', ')+'. Use YYYY-MM-DD in Theme settings > Production calendar.':
          'Cart closure notice is hidden from shoppers outside its notice window. Manage dates in Theme settings > Production calendar, or turn on Preview next closure in editor.';
      }
    }
    if(editor&&cal.invalid.length)root.setAttribute('data-calendar-invalid',cal.invalid.join(', '));
    else root.removeAttribute('data-calendar-invalid');
  }
  function refresh(){
    document.querySelectorAll('[data-closure-ribbon],[data-closure-cart]').forEach(update);
  }
  window.DIYClosureNotices={refresh:refresh};
  refresh();
  var timer=setInterval(refresh,30000);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)refresh();});
  window.addEventListener('pageshow',refresh);
  window.addEventListener('resize',refresh);
  document.addEventListener('shopify:section:load',function(event){
    refresh();
    if(window.DIYInitTurnaround)event.target.querySelectorAll('.cstc').forEach(window.DIYInitTurnaround);
    if(window.DIYInitHeaderETA)event.target.querySelectorAll('[data-eta-block]').forEach(window.DIYInitHeaderETA);
  });
  document.addEventListener('shopify:section:unload',function(event){
    event.target.querySelectorAll('.cstc').forEach(function(root){if(root._cstcCleanup)root._cstcCleanup();});
    event.target.querySelectorAll('[data-eta-block]').forEach(function(root){if(root._etaCleanup)root._etaCleanup();});
  });
})();
